import UAParser from 'ua-parser-js';

/**
 * Checks the user agent to best guess whether the device is mobile.
 * Safe to use on the server, but needs the user agent to be passed
 * in as an argument, can be retrieved from the request headers
 *
 * @example
 * const userAgent = headers().get('user-agent');
 * const isProbablyMobileDevice = isMobileDevice(userAgent);
 */
export const isMobileDevice = (userAgent) => {
  const parser = new UAParser(userAgent);
  const result = parser.getResult();
  return result?.device?.type === 'mobile';
};
